<template>
  <div :class="{ calrendarFlex: flexStyle }">
    <Calendar @onClickDay="onClickDay" :showSelectDay="true" :courseDate="times"></Calendar>
    <div class="flex-list">
      <div class="list" v-if="list.length > 0">
        <div v-for="(item, index) in list" :key="index" class="item-list">
          <template v-if="item.course_type != 0">
            <div class="item-card">
              <div class="line"></div>
              <div class="main">
                <div class="main-line"></div>
                <div class="main-content">
                  <div class="left">
                    <div class="time">
                      {{ new Date(item.start_play * 1000).format('hh:mm') }}-{{
                        new Date(item.end_play * 1000).format('hh:mm')
                      }}
                    </div>
                    <div class="state-wrap">
                      <span
                        class="state"
                        :class="'state-' + item.live_status"
                        v-if="
                          item.course_type == 2 ||
                          item.course_type == 3 ||
                          item.course_type == 15 ||
                          item.course_type == 1 ||
                          item.class_type == 1
                        "
                      >
                        <span v-if="item.live_status == 0">未开始</span>
                        <span v-else-if="item.live_status == 1" class="living">
                          <span class="primary-color">直播中</span>
                        </span>
                        <span
                          v-else-if="
                            item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                          "
                        >
                          <span>已结束</span>
                        </span>
                      </span>
                      <span
                        v-if="item.course_type == 7 || item.class_type == 2"
                        class="state"
                        :class="'state-' + item.live_status"
                      >
                        <span v-if="item.live_status == 0">未开始</span>
                        <span v-else-if="item.live_status == 1">
                          <span class="primary-color">上课中</span>
                        </span>
                        <span
                          v-else-if="
                            item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                          "
                        >
                          <span>已结束</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div @click="showDialog(item)" style="cursor: default">
                    <!-- 隐藏课时类型 -->
                    <!-- <span class="type">{{ item.course_type_name }}</span> -->
                    <span class="type-arrange" v-if="item.arrange_id">
                      <span>{{ item.class_type == 1 ? '直播' : '面授' }}</span>
                    </span>
                    <span class="title">
                      <template v-if="item.type == 1">
                        <span v-if="item.chapter_title" style="margin-right: 12px">
                          {{ item.chapter_title }}
                        </span>
                      </template>
                      <template v-if="item.arrange_id">
                        <span v-if="item.classify_name" style="margin-right: 12px">
                          <span>{{ item.classify_name }}</span>
                        </span>
                        <span v-if="item.grade_name" style="margin-right: 10px">
                          <span>{{ item.grade_name }}</span>
                        </span>
                        <span v-if="item.sub_name">{{ item.sub_name }}</span>
                      </template>
                      <span v-else-if="item.course_type != 1">
                        {{ item.title }}
                      </span>
                      <span v-else>{{ item.teacher_name }}</span>
                    </span>
                  </div>
                  <div class="subtitle" v-if="item.course_title">
                    {{ item.course_title }}
                  </div>
                  <div class="subtitle" v-else-if="item.oto_desc">
                    {{ item.oto_desc }}
                  </div>
                  <template v-else-if="item.arrange_id">
                    <div class="subtitle" v-if="item.teacher_name">
                      {{ item.teacher_name }}
                    </div>
                    <div class="subtitle" v-if="item.province_name">
                      上课地点：{{ item.province_name }}{{ item.city_name }}{{ item.district_name
                      }}{{ item.address }}
                    </div>
                    <div class="subtitle" v-if="item.room_name">上课教室：{{ item.room_name }}</div>
                  </template>
                  <template v-if="item.type == 1 || item.type == 2">
                    <FileList :fileList="item.notes || []" />
                  </template>
                  <template v-if="item.type != 1 && item.type != 2 && item.notes_status == 1">
                    <FileList :fileList="[{ ...item, ware_filename: item.notes_name }]" />
                  </template>
                </div>
                <div class="live-state">
                  <template>
                    <span
                      class="text-disabled disabled"
                      v-if="
                        item.leave_status &&
                        item.leave_status == 3 &&
                        item.leave_allow &&
                        item.leave_allow != 1
                      "
                    >
                      请假驳回
                    </span>
                    <span
                      class="text-disabled disabled"
                      v-if="
                        item.leave_status &&
                        item.leave_status == 3 &&
                        item.leave_allow &&
                        item.leave_allow == 1
                      "
                    >
                      请假驳回，重新请假
                    </span>
                    <span
                      class="period-living"
                      @click="onLeave(item)"
                      v-if="item.leave_allow && item.leave_allow == 1"
                    >
                      请假
                    </span>
                    <span
                      class="text-disabled disabled"
                      v-if="item.leave_status && item.leave_status == 2"
                    >
                      已请假
                    </span>
                    <span
                      class="text-disabled disabled"
                      v-if="item.leave_status && item.leave_status == 1"
                    >
                      已请假，待审批
                    </span>
                  </template>
                  <template
                    v-if="
                      item.course_type == 1 ||
                      item.course_type == 2 ||
                      item.course_type == 3 ||
                      item.course_type == 15 ||
                      item.course_type == 16
                    "
                  >
                    <span
                      v-if="item.live_status == 0"
                      class="period-living"
                      @click.stop="goToPlay(item)"
                    >
                      立即进入
                    </span>
                    <span
                      v-else-if="item.live_status == 1"
                      class="period-living"
                      @click.stop="goToPlay(item)"
                    >
                      立即进入
                    </span>
                    <template v-else>
                      <template v-if="item.course_type == 16">
                        <span v-if="item.live_status == 3" @click.stop="goToPlay(item, 1)">
                          查看大教室回放
                        </span>
                        <span class="disabled" v-else :style="{ cursor: 'not-allowed' }">
                          查看大教室回放
                        </span>
                        <span v-if="item.min_live_status == 3" @click.stop="goToPlay(item, 2)">
                          查看小教室回放
                        </span>
                        <span class="disabled" v-else :style="{ cursor: 'not-allowed' }">
                          查看小教室回放
                        </span>
                      </template>
                      <template v-else>
                        <span v-if="item.live_status == 3" @click.stop="goToPlay(item)">
                          查看回放
                        </span>
                        <span class="disabled" v-else :style="{ cursor: 'not-allowed' }">
                          查看回放
                        </span>
                      </template>
                    </template>
                  </template>
                  <template v-else-if="item.arrange_id && item.buttons.length > 0">
                    <span @click.stop="onPeriodClick(item, item.buttons[0])">
                      {{ item.buttons[0].name }}
                    </span>
                    <span
                      v-if="item.buttons.length > 1"
                      class="more"
                      @click.stop="
                        hideAll();
                        item.showMore = true;
                      "
                    ></span>
                    <div v-if="item.showMore" class="more-panel">
                      <template v-for="(btn, index) in item.buttons">
                        <div
                          v-if="index > 0"
                          class="more-item"
                          :key="btn.id"
                          @click.stop="onPeriodClick(item, btn)"
                        >
                          {{ btn.name }}
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-if="item.course_type == 0">
            <MeetingCard :item="getMeetingInfo(item)" @goToPlay="goToMeeting" />
          </template>
        </div>
      </div>
      <EmptyNew class="empty" title="暂无内容" v-else />
    </div>
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip v-if="showSoldOut" :show.sync="showSoldOut"></CourseSoldOutTip>
    <MemberArrangeItem
      ref="arrange"
      v-show="false"
      :item="currentArrangeItem"
      :type="currentArrangeItem.type == 1 || currentArrangeItem.type == 2 ? 1 : 2"
      @leave="getData"
    ></MemberArrangeItem>
    <LeaveModal
      :show-modal.sync="showModal"
      :onLeaveSubmit="onLeaveSubmit"
      :period="leave.course"
    />
  </div>
</template>
<script>
import Calendar from '@/components/Calendar.vue';
import CourseSoldOutTip from '@/modules/stu/components/CourseSoldOutTip.vue';
import MeetingCard from '@/modules/stu/components/classes/MeetingCard';
import MemberArrangeItem from '@/modules/stu/views/periods/components/MemberArrangeItem.vue';
import LeaveModal from '@/modules/stu/components/classes/LeaveModal';
import EmptyNew from '@/components/EmptyNew.vue';
import FileList from '@/modules/stu/components/FileList';
import CourseContentTip from '@/modules/stu/components/CourseContentTip';
import * as enums from '@/utils/enums.js';

export default {
  name: 'StudyCalendar',
  props: {
    timesUrl: {
      type: String,
      default: '/api/app/study/schedule',
    },
    dateUrl: {
      type: Function,
    },
    flexStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContentDialog: false,
      chapter_content: '',
      times: [],
      list: [],
      id: this.$route.params.id,
      showModal: false,
      leave: {
        course: {},
      },
      showSoldOut: false,
      time: 0,
      currentArrangeItem: {},
      hideMore: null,
      fileList: [],
    };
  },
  components: {
    Calendar,
    CourseSoldOutTip,
    MemberArrangeItem,
    MeetingCard,
    LeaveModal,
    EmptyNew,
    FileList,
    CourseContentTip,
  },
  async created() {
    this.times = await this.$http.get(this.timesUrl);
    this.time = parseInt(new Date().getTime() / 1000);
    await this.getData();
    this.$emit('load');
  },
  mounted() {
    this.hideMore = () => {
      this.hideAll();
    };
    document.addEventListener('click', this.hideMore);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMore);
  },
  methods: {
    showDialog(row) {
      if (row.periods_type == 7) {
        this.showContentDialog = true;
        this.chapter_content = row.content;
      }
    },
    getMeetingInfo(item) {
      let live_status;
      if (item.live_status == 0) {
        live_status = 1;
      } else if (item.live_status == 1) {
        live_status = 2;
      } else {
        live_status = 3;
      }
      return {
        ...item,
        start_time: item.start_play,
        end_time: item.end_play,
        live_status: live_status,
      };
    },
    //进入班会  id,type
    goToMeeting(data, type) {
      this.$livePlay(0, 'meeting', {
        id: 0,
        title: data.meeting_name,
        meeting_id: data.id,
        type: type,
      });
    },
    //请假
    onLeave(course) {
      this.leave.course = course;
      this.showModal = true;
    },
    async onLeaveSubmit(leaveInfo) {
      await this.$http.post('/api/app/leave', {
        leave_cause: leaveInfo.content,
        class_id: this.id,
        course_id: this.leave.course.course_basis_id,
        course_periods_id: this.leave.course.periods_id,
        uid: this.$store.state.user_info.id,
      });
      await this.getData();
    },
    async getData() {
      let url;
      if (this.dateUrl) {
        url = this.dateUrl(this.time);
      } else {
        url = '/api/app/study/live/' + this.time;
      }
      let list = await this.$http.get(url);
      let ts = parseInt(new Date().getTime() / 1000);
      list.forEach((item) => {
        if (item.arrange_id) {
          item.course_type_name = enums.PeriodsType.getValue(item.type);
          if (ts < item.start_play) {
            item.live_status = 0;
          } else if (ts >= item.start_play && ts <= item.end_play) {
            item.live_status = 1;
          } else {
            item.live_status = 2;
          }
          item.is_leave = item.is_leave == 2 ? 1 : 0;
          item.showMore = false;
          item.buttons = [];
          if (item.class_type == 1) {
            if (item.live_status == 0 || item.live_status == 1) {
              item.buttons.push({ id: 'play', name: '进入直播间' });
            } else if (item.bjy_encode_status == 1) {
              item.buttons.push({ id: 'play', name: '查看回放' });
            }
          }
          // if (item.notes_status == 1 && item.type != 1 && item.type != 2) {
          //   item.buttons.push({ id: "notes", name: "下载讲义" });
          // }
          // if (item.is_leave == 1) {
          //   item.buttons.push({ id: "leave", name: "请假" });
          // }
          if (item.attend_status == 1 && item.live_status == 2) {
            if (item.t_remark) {
              item.buttons.push({ id: 'tremark', name: '查看老师评价' });
            }
            item.buttons.push({
              id: 'sremark',
              name: item.s_remark ? '查看评价' : '评价',
            });
          }
        } else {
          item.mixType = item.course_type;
          item.course_type = item.periods_type || item.course_type;
          item.course_type_name = enums.CoursePeriodsType.getValue(item.course_type);
        }
      });
      this.list = list;
    },
    async onClickDay(date) {
      this.time = parseInt(new Date(date).getTime() / 1000);
      await this.getData();
    },
    async goToPlay(item, type) {
      if (item.status == 2 && item.is_go_to_study == 0) {
        this.showSoldOut = true;
        return;
      }
      if (item.course_type == 16) {
        if (!type) {
          type = 2;
        }
      } else if (!type) {
        type = 1;
      }
      if (type == 1 && (item.live_status == 2 || item.live_status == 4)) {
        return;
      }
      if (type == 2 && (item.min_live_status == 2 || item.min_live_status == 4)) {
        return;
      }
      if (item.valid_status != 1) {
        return this.$info('该课程已过期，无法继续学习');
      }
      if (item.course_type != 1) {
        await this.$services.CourseService.checkLimit(item.course_basis_id, item.course_chapter_id);
      }
      this.$livePlay(item.course_basis_id, item.course_type, {
        id: item.course_chapter_id,
        title: item.title,
        type: type,
        period_id: item.periods_id,
      });
    },
    async onPeriodClick(item, button) {
      this.currentArrangeItem = item;
      await this.$nextTick();
      if (button.id == 'play') {
        this.$refs.arrange.onPlay();
      } else if (button.id == 'notes') {
        this.$refs.arrange.onDownload(item);
      } else if (button.id == 'leave') {
        this.$refs.arrange.onLeave();
      } else if (button.id == 'tremark') {
        this.$refs.arrange.onTeacherComment();
      } else if (button.id == 'sremark') {
        this.$refs.arrange.onComment();
      }
      this.hideAll();
    },
    hideAll() {
      this.list.forEach((item) => {
        item.showMore = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.calrendarFlex {
  padding-left: 16px;
  display: flex;
  align-items: center;
  .calendar {
    width: 35%;
  }
  .flex-list {
    width: 65%;
  }
}
.list {
  padding: 26px 24px 30px 0;
}
.item-list {
  &:last-child {
    ::v-deep .line::after {
      display: none !important;
    }
    ::v-deep .main {
      margin-bottom: 0 !important;
    }
  }
}
.item-card {
  display: flex;
  //&:last-child {
  //  .line::after {
  //    display: none;
  //  }
  //  .main {
  //    margin-bottom: 0;
  //  }
  //}
  .left {
    margin-right: 16px;
    display: flex;
    margin-bottom: 13px;
  }
  .main {
    flex: 1;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    border: 1px solid #e6e6e6;
    border-left: none;
    padding: 18px 16px 18px 18px;
    position: relative;
  }
  .main-line {
    position: absolute;
    height: 100%;
    width: 4px;
    left: 0;
    top: 0;
    background: #f39b10;
  }
  .main-content {
    flex: 1;
  }
  .time {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    height: 22px;
    line-height: 22px;
    display: flex;
    margin-right: 20px;
  }
  .line {
    position: relative;
    width: 10px;
    margin: 0 24px 0 0;

    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      box-sizing: border-box;
      border: 2px solid #f39b10;
      border-radius: 50%;
      background: #fce6c3;
      z-index: 1;
      top: 24px;
    }
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 100%;
      box-sizing: border-box;
      border-left: 2px dashed #dadada;
      left: 4px;
      top: 30px;
    }
  }
  .type {
    font-size: 12px;
    color: $primary-color;
    background: $primary-color-light;
    padding: 3px 6px;
    border-radius: 4px;
    margin-right: 8px;
  }
  .type-arrange {
    font-size: 12px;
    color: #ec8e0f;
    background: #fff5dc;
    padding: 3px 6px;
    border-radius: 4px;
    margin-right: 10px;
  }
  .state-wrap {
    display: flex;
    padding-top: 2px;
  }
  .state {
    font-size: 14px;
    color: #999999;
    padding-left: 20px;
    background-image: url('~@/assets/images/calendar/end@2x.png');
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: left center;
  }
  .state-0 {
    background-image: url('~@/assets/images/calendar/wait@2x.png');
  }
  .state-1 {
    background-image: url('~@/assets/images/calendar/living@2x.png');
  }
  .living {
    color: $primary-color;
  }
  .title {
    font-size: 14px;
  }
  .subtitle {
    color: #999999;
    margin-top: 8px;
  }
  .subtitle-line {
    margin: 0 8px;
    color: #d8d8d8;
  }
  .live-state {
    display: flex;
    position: relative;
    span {
      font-size: 14px;
      border: 1px solid #bfbfbf;
      cursor: pointer;
      border-radius: 19px;
      margin-left: 10px;
      padding: 7px 20px;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        border-color: $primary-color;
        color: $primary-color;
      }
      &.disabled {
        color: #333333;
        background: #f5f5f5;
        opacity: 0.5;
        cursor: not-allowed !important;

        &:hover {
          background: #f5f5f5;
          color: #333333;
          cursor: default;
          border-color: #bfbfbf;
        }
      }
    }
    .text-disabled {
      position: relative;
      top: 2px;
      border: none;
      cursor: default;
      vertical-align: middle;
      &.disabled {
        color: #999;
        background: #fff;
        &:hover {
          background: #fff;
          color: #999;
          cursor: default;
        }
      }
    }
    .more {
      width: 36px;
      padding: 0;
      text-align: center;
      line-height: 34px;
      background: url('~@/assets/images/calendar/more@2x.png') no-repeat center center/16px 4px;
    }
    .more-panel {
      position: absolute;
      right: 0;
      top: 40px;
      width: 128px;
      padding: 4px 0;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .more-item {
      height: 36px;
      padding-left: 12px;
      line-height: 36px;
      cursor: pointer;
      &:hover {
        background: $primary-color-light;
        color: $primary-color;
      }
    }
  }
}
</style>
